import React, { useEffect } from 'react';

const DinosaurGame = () => {
  useEffect(() => {
    const preventScroll = (event) => {
      const keysToPrevent = ['ArrowUp', 'ArrowDown', 'Space'];
      if (keysToPrevent.includes(event.key)) {
        event.preventDefault();
      }
    };

    window.addEventListener('keydown', preventScroll);
    window.addEventListener('keyup', preventScroll);

    return () => {
      window.removeEventListener('keydown', preventScroll);
      window.removeEventListener('keyup', preventScroll);
    };
  }, []);

  return (
    <iframe
      className="dinoSaur"
      src="/dinosaur-game/index.html"
      width="800"
      height="400"
      style={{ border: 'none' }}
      title="Dinosaur Game"
    ></iframe>
  );
};

export default DinosaurGame;